import React from "react";
import ContentEditable from "react-contenteditable";
export const SliderInput = (props) => {
    return (React.createElement("div", { className: "flex flex-row bg-anthracite-10 px-12 py-6" },
        React.createElement(ContentEditable, { tagName: "p", html: props.value, disabled: false, autoFocus: true, role: "textbox", "aria-label": props.ariaLabel, onChange: (event) => {
                props.onChange(event.target.value);
            } }),
        props.unit && React.createElement("span", null,
            "\u00A0",
            props.unit)));
};
